var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewFullScreeningQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9523 1.9048C8.9523 1.58921 9.20814 1.33337 9.52373 1.33337H14.0952C14.4107 1.33337 14.6666 1.58921 14.6666 1.9048V6.47623C14.6666 6.79182 14.4107 7.04766 14.0952 7.04766C13.7796 7.04766 13.5237 6.79182 13.5237 6.47623V3.28435L6.88017 9.92791C6.65701 10.1511 6.2952 10.1511 6.07205 9.92791C5.84889 9.70475 5.84889 9.34295 6.07205 9.11979L12.7156 2.47623H9.52373C9.20814 2.47623 8.9523 2.22039 8.9523 1.9048ZM3.42849 4.00004C2.9025 4.00004 2.47611 4.42644 2.47611 4.95242V12.5715C2.47611 13.0975 2.9025 13.5238 3.42849 13.5238H11.0475C11.5735 13.5238 11.9999 13.0975 11.9999 12.5715V9.52385C11.9999 9.20826 12.2558 8.95242 12.5713 8.95242C12.8869 8.95242 13.1428 9.20826 13.1428 9.52385V12.5715C13.1428 13.7286 12.2047 14.6667 11.0475 14.6667H3.42849C2.27132 14.6667 1.33325 13.7286 1.33325 12.5715V4.95242C1.33325 3.79525 2.27132 2.85718 3.42849 2.85718H6.47611C6.7917 2.85718 7.04754 3.11302 7.04754 3.42861C7.04754 3.7442 6.7917 4.00004 6.47611 4.00004H3.42849Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFullScreeningQuestion);
export default __webpack_public_path__ + "static/media/view-full-screening-question.4fb3d59060ff81311d7d14f14114d429.svg";
export { ForwardRef as ReactComponent };